module.exports = __webpack_public_path__ + "img/u-thumbnail.4e541204.svg";